<style scoped>
    .wrapper {
        display: inline-block;
    }
    .ivu-checkbox-wrapper{
        display: block;
        margin: 10px 0;
    }
</style>
<template>
  <div class="wrapper">
    <v-btn @click="showModal">
      工资计提
    </v-btn>

    <Modal
      v-model="config.modal"
      title="工资计提"
      @on-ok="editOk"
    >
      <DatePicker
        type="month"
        :value="params.month"
        placeholder="选择月份"
        style="width: 200px"
        @on-change="monthChange"
      />
      <CheckboxGroup v-model="params.bills">
        <Checkbox label="formal">
          正式员工工资计提
        </Checkbox>
        <Checkbox label="informal">
          实习生津贴计提
        </Checkbox>
        <Checkbox label="outsource">
          兼职外包工资计提
        </Checkbox>
        <Checkbox label="rec_award">
          实习生推荐奖计提
        </Checkbox>
      </CheckboxGroup>
    </Modal>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        params: {
          month: '',
          bills: []
        },
        config: {
          modal: false,
          loading: true
        }
      }
    },
    computed: {
      cur_customer() {
        return this.$store.state.cur_customer;
      },
    },
    created() {
      //
    },
    mounted() {
      //
    },
    methods: {
      monthChange(month) {
        this.params.month = month;
      },
      showModal() {
        this.config.modal = true;
      },
      checkValid() {
        let err_msg = '';
        if (!this.params.month) {
          err_msg += "<p>请选择月份</p>";
        }
        if (!this.params.bills.length) {
          err_msg += "<p>请选择你要生成的单据</p>";
        }
        if (err_msg) {
          this.$Modal.error({title: '错误提示', content: err_msg});
          this.resetLoading();
          return false;
        }
        return true;
      },
      resetLoading() {
        this.config.loading = false;
        setTimeout(() => {
          this.config.loading = true;
        }, 500);
      },
      editOk() {
        if (this.checkValid()) {
          this.$util.ajax.post(this.$util.api.gen_accrual_bills, this.params).then((response) => {
            return response.data;
          }).then((res) => {
            console.log(res);
            if (res.code === 1) {
              this.config.modal = false;
              this.$Message.success({content: '你的申请已提交，请查看企业微信结果通知', duration: 3});
            } else {
              this.$Modal.warning({title: '错误', content: res.msg});
            }
          }).catch((e) => {
            this.$Modal.warning({title: '错误', content: e.message});
          }).finally(() => {
            this.resetLoading();
          });
        } else {
          //this.$Message.success({content: '你的申请已提交，请2分钟后查看', duration: 3});
        }
      }
    }
  }
</script>
